import { render, staticRenderFns } from "./m-orm-view-table.vue?vue&type=template&id=2d1fe948&lang=pug&"
import script from "./m-orm-view-table.vue?vue&type=script&lang=js&"
export * from "./m-orm-view-table.vue?vue&type=script&lang=js&"
import style0 from "./m-orm-view-table.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VCol } from 'vuetify/lib/components/VGrid';
import { VRow } from 'vuetify/lib/components/VGrid';
import { VSimpleTable } from 'vuetify/lib/components/VDataTable';
installComponents(component, {VCol,VRow,VSimpleTable})
